export default __webpack_public_path__ + "images/c3f53613298e6c47813ebcbbe0d91d11-2_tablet_1067x470.jpg";